<template>
  <div>
    <div class="change-fligth-content" v-for="(item,index) in flights" :key="index">
      <div class="fligth-nav">
        <el-col :span="6">航司/航班号</el-col>
        <el-col :span="3">机型</el-col>
        <el-col :span="6">起飞时间/起飞机场</el-col>
        <el-col :span="6">到达时间/到达机场</el-col>
        <el-col :span="3">餐饮</el-col>
        <el-col :span="2">操作</el-col>
      </div>
      <div class="flight-box">
        <el-col :span="6">
          <div class="flex-center">
            <img :src="item.airCompanyLogoImg" alt="">
            <span class="title">{{item.airCompanyName}}</span>
            <span class="title">{{item.flightNo}}</span>
          </div>
        </el-col>
        <el-col :span="3" class="flight-text">
          <span class="title">{{item.planeType}}</span>
        </el-col>
        <el-col :span="6" class="arrows-box">
          <h3>{{item.depTime}}</h3>
          <p>{{item.depAirportName}} {{item.depTerminal}}</p>
          <div class="arrows"></div>
        </el-col>
        <el-col :span="6">
          <h3>{{item.arrTime}}</h3>
          <p>{{item.arrAirportName}} {{item.arrTerminal}}</p>
        </el-col>
        <el-col :span="3" class="flight-text">{{item.isHasMeal==1?'有':'没有'}}</el-col>
        <el-col :span="2" class="flight-text">
          <el-button
            :type="item.btnShow?'success':''"
            size="mini"
            :disabled="item.btnStop&&!item.btnShow"
            @click="getChildAirInfo(item,item.btnShow),selectBtn(item,index)"
          >{{item.btnShow?'已选择':'选 择'}}</el-button>
        </el-col>
      </div>
      <div class="flight-foot">
        <el-col :span="5">
          {{Math.floor(item.policys[0].cabin.discount*100)}}折 ({{
          item.policys[0].cabin.cabinName}} / {{item.policys[0].cabin.chdCabinCode}}）
        </el-col>
        <!-- <el-col :span="5">座位数>=9</el-col> -->
        <el-col :span="5">儿童票面价：{{item.policys[0].priceData[0].price}}</el-col>
        <el-col :span="5">产品类型：
          <el-tag
            :type="item.policys[0].productTypeTxt=='平台优选'?'success':
                 item.policys[0].productTypeTxt=='低价推荐'?'warning':''"
            effect="dark"
            style="color:white;"
          >{{item.policys[0].productTypeTxt}}</el-tag>
        </el-col>
        <el-col :span="8" class="text-rule">
          <span
            @mouseenter="backRule(item),indexShow = index"
            @mouseleave="ruleText='',indexShow = null"
          >退改规则</span>
          <div class="text-rule-box" v-if="ruleText&&indexShow==index">
            <ChangClause :ruleText="ruleText"/>
          </div>
        </el-col>
      </div>
    </div>
  </div>
</template>
<script>
import ChangClause from "./changClause";
import rule from "@/lib/data-service/flight/newFligthApi/buyer_dom_white_rule";

export default {
  name: "tableFligth",
  data() {
    return {
      ruleText: "",
      detailList: {},
      selectList: [],
      indexShow: null,
      activeBtn: {}
    };
  },
  components: { ChangClause },
  props: {
    getChildAirInfo: {
      type: Function,
      default: () => {
        return "start";
      }
    },
    flights: {
      type: Array,
      default: []
    },
    arrIndex: Number
  },
  watch: {
    activeBtn: {
      handler: function(newV, oldV) {
        this.$emit("activeBtn", newV);
      },
      deep: true
    }
  },
  methods: {
    //退改规则
    backRule(val) {
      this.ruleText = "";
      let data = {
        arrCityPortCode: val.arrAirportCode,
        cabinCode: val.policys[0].cabin.chdCabinCode,
        depCityPortCode: val.depAirportCode,
        depDate: val.depDate,
        flightNo: val.flightNo,
        flightType: this.flights.length > 1 ? 2 : 1,
        psgType: 2,
        supplierType: val.supplierType,
        policyId: val.policys[0].policyId,
        extData: val.policys[0].extData,
      };
      rule(data).then(res => {
        let refRule = res.refRule.rules;
        let chaRule = res.chaRule.rules;
        refRule.map(item => (item.type = "refRule"));
        chaRule.map(item => (item.type = "chaRule"));
        this.ruleText = [refRule, chaRule];
        // this.ruleText = res.chaRule.content;
      });
    },

    selectBtn(val, index) {
      if (val.btnShow) {
        val.btnShow = false;
        this.flights.map(item => {
          item.btnStop = false;
        });
      } else {
        val.btnShow = true;
        this.flights.map(item => {
          item.btnStop = true;
        });
      }

      this.activeBtn.show = val.btnShow;
      this.activeBtn.active = this.arrIndex + "," + index;
      this.$forceUpdate();
    }
  }
};
</script>
<style lang="less" scoped>
.change-fligth-content {
  &::after {
    content: "";
    display: block;
    clear: both;
  }
  .fligth-nav {
    float: right;
    display: flex;
    width: 100%;
    padding: 8px 10px;
    background: #f1f3f5;
    font-size: 13px;
    color: #666;
  }
  .flight-box {
    float: right;
    display: flex;
    width: 100%;
    padding: 20px 10px;
    img {
      width: 35px;
      height: 35px;
      border-radius: 50%;
      margin-right: 10px;
    }
    .title {
      font-size: 14px;
    }
    h3 {
      font-size: 25px;
      color: #393b3e;
    }
    p {
      font-size: 13px;
      color: #929292;
    }
  }
  .flight-foot {
    display: flex;
    width: 100%;
    padding: 10px 100px;
    background: #f3f9fe;
    font-size: 13px;
    .el-col {
      display: flex;
      align-items: center;
    }
  }
  .flight-text {
    color: #666;
    font-size: 14px;
    transform: translateY(10px);
  }
  .arrows-box {
    position: relative;
  }
  .arrows {
    position: absolute;
    right: -15%;
    top: 33%;
    display: block;
    width: 75px;
    height: 2px;
    background: #a3a3a3;
    &::before {
      width: 0;
      height: 0;
      border-width: 7px 0 7px 7px;
      border-style: solid;
      border-color: transparent transparent transparent #a3a3a3;
      position: absolute;
      content: "";
      display: block;
      right: -7px;
      top: -6px;
    }
  }
}
.text-rule {
  color: #409eff;
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  position: relative;
  .text-rule-box {
    position: absolute;
    top: 29px;
    right: -80%;
    width: 500px;
    border: 1px solid #237dc8;
    background: white;
    z-index: 999;
  }
}
.el-button {
  border-radius: 0;
}
.el-tag {
  border-radius: 0;
  padding: 0 5px;
  height: auto;
  line-height: 24px;
}
</style>